import { render } from "./ShowCategories.vue?vue&type=template&id=5e3f15d3"
import script from "./ShowCategories.vue?vue&type=script&lang=js"
export * from "./ShowCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__